import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import LoginLayout from 'src/ui/features/Login/presentational/layout/LoginLayoutPres';
import LoginContainer from 'src/ui/features/Login/containers/LoginContainer';
import { updateBodyClass } from 'src/helpers';
import { LOGIN_URL, BODY_CLASSES } from 'src/constants/constants.js';

class LoginRoot extends React.Component {
  componentDidMount() {
    sessionStorage.removeItem('CN');
    updateBodyClass(BODY_CLASSES.LOGIN);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.LOGIN);
  }

  render() {
    return (
      <LoginLayout skipAuth={true} isRoleSelect={this.props.isRoleSelect}>
        <Switch>
          <Route path={LOGIN_URL} render={props => <LoginContainer key={'login'} {...props} isRoleSelect={this.props.isRoleSelect} />} />
        </Switch>
      </LoginLayout>
    );
  }
}

const mapDispatchToProps = {};

const mapStateToProps = state => {
  return {
    isRoleSelect: state.login.isRoleSelect,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginRoot);
